import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseCircleOutline from 'mdi-react/CloseCircleOutlineIcon';

import styles from '../../../common/VerifyModal/VetifyModal.module.scss';

type Props = {
  show: boolean;
  onHide: () => void;
  onClickVerify: (e: any) => void;
  textTitle: string;
  textBody?: string;
  acceptBtn?: string;
  declineBtn?: string;
};

const ModalAcept: React.FC<Props> = ({
  show,
  onHide,
  onClickVerify,
  textTitle,
  textBody = '',
  declineBtn = 'Так',
  acceptBtn = 'Ні',
}) => (
  <React.Fragment>
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className={styles.modal}
      onClick={(e: any) => e.stopPropagation()}
    >
      <Modal.Header className="border-bottom-0 justify-content-end">
        <Button variant="outine-light d-flex justify-content-end" onClick={onHide}>
          <CloseCircleOutline className="text-secondary" />
        </Button>
      </Modal.Header>
      <Modal.Body className="d-flex align-items-center flex-column px-4 pb-4">
        <p className="text-center display-4">{textTitle}</p>
        <p className="text-center">{textBody}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-around border-top-0 mt-3 mb-4">
        <Button variant="secondary" onClick={onHide} className="py-2 text-uppercase w-140 \">
          {acceptBtn}
        </Button>
        <Button onClick={onClickVerify} variant="danger" id="onVerifyCode" className="px-4 py-2 text-uppercase w-140">
          {declineBtn}
        </Button>
      </Modal.Footer>
    </Modal>
  </React.Fragment>
);

export default ModalAcept;
